import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { registerField } from 'core/forms';

import styles from '../styles/formFieldColorPicker.module.scss';

const FormFieldColorPicker = ({
  schema = { options: [], default: '' },
  updateField = () => {},
  value = '',
}) => {
  const { options = [], default: defaultColor } = schema;
  const selectedColor = value || defaultColor;

  return (
    <div className={styles.element}>
      {options.map((color) => (
        <button
          key={color}
          type="button"
          className={classnames(styles.colorButton, {
            [styles.isSelected]: color === selectedColor,
          })}
          onClick={() => updateField(color)}
          aria-label={`Select color ${color}`}
          title={color}
        >
          <div
            className={styles.colorSwatch}
            style={{ backgroundColor: color }}
          />
        </button>
      ))}
    </div>
  );
};

FormFieldColorPicker.propTypes = {
  schema: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.string),
    default: PropTypes.string,
  }),
  value: PropTypes.string,
  updateField: PropTypes.func,
};

registerField('ColorPicker', React.memo(FormFieldColorPicker));

export default FormFieldColorPicker;